import Glider from 'glider-js/glider'; 

export default () => {
    let gliderGallery = document.querySelectorAll('.js-gallery');
    if (gliderGallery){ 
        gliderGallery.forEach(element => {
            let initGlider = new Glider(element, {
                slidesToShow: 1,
                draggable: true,
            });

            initGlider.setOption({
                arrows: {
                    prev: element.nextElementSibling.querySelector('.js-gallery-prev.glider-prev'),
                    next: element.nextElementSibling.querySelector('.js-gallery-next.glider-next'),
                },
            });

            initGlider.refresh(true);

        });
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/initialize-glider.js